import { render, staticRenderFns } from "./ClientProductDetail.vue?vue&type=template&id=89c8c7a8&scoped=true&"
import script from "./ClientProductDetail.vue?vue&type=script&lang=js&"
export * from "./ClientProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientProductDetail.vue?vue&type=style&index=0&id=89c8c7a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c8c7a8",
  null
  
)

export default component.exports